import map from 'lodash/map';
import size from 'lodash/size';
import { MapMarker, MapMarkerActive } from '@yme/assets/icons';
import { ICON_SIZE } from '@yme/atoms/svg-icon';
import { getBoundsByPoints } from '@yme/utils/location';
import { DEFAULT_MAP_OPTIONS } from './constants';
// looks like either @react-google-maps/api or google api
// have some unexpected offset in anchor's calculations,
// so we added 'delta' to take it into account
const DELTA = 2;
export const getMarkerIcon = (isActive) => {
    if (isActive) {
        return {
            url: MapMarkerActive,
            anchor: new google.maps.Point(ICON_SIZE.l / 2 - DELTA, ICON_SIZE.s + (ICON_SIZE.l - ICON_SIZE.s) / 2 - DELTA),
        };
    }
    return {
        url: MapMarker,
        anchor: new google.maps.Point(ICON_SIZE.s / 2, ICON_SIZE.s),
    };
};
export const areMarkersChanged = (currentMarkers, prevMarkers) => size(currentMarkers) !== size(prevMarkers);
export const getMapOptions = (mapOptions, isFullscreen) => {
    const gestureHandling = isFullscreen
        ? 'greedy'
        : mapOptions?.gestureHandling || DEFAULT_MAP_OPTIONS.gestureHandling;
    return {
        ...DEFAULT_MAP_OPTIONS,
        ...mapOptions,
        gestureHandling,
    };
};
export const fitMapToMarkers = (mapInstance, markers) => {
    const bounds = getBoundsByPoints(map(markers, ({ latitude, longitude }) => ({
        lat: latitude,
        lng: longitude,
    })));
    mapInstance.fitBounds(bounds);
};
